if (!customElements.get('bundle-tiers')) {
  customElements.define(
    'bundle-tiers',
    class BundleTiers extends HTMLElement {
      connectedCallback() {
        this.productId = String(this.dataset.productId);
        this.price = parseInt(this.dataset.price, 10) || 0;
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
        });

        this.querySelectorAll('input[type="radio"]').forEach((radio) =>
          radio.addEventListener('change', () => this.setQuantity(radio.value))
        );

        const checked = this.querySelector('input[type="radio"]:checked');
        if (checked) this.setQuantity(checked.value);

        // Boost varianto keitimo įvykis (jQuery)
        if (window.jQuery) {
          this.onVariant = (event, args) => {
            if (!args || !args.variant || !args.product) return;
            if (String(args.product.id) !== this.productId) return;
            this.price = args.variant.price;
            this.updatePrices();
          };
          window.jQuery(window).on('cc-variant-updated', this.onVariant);
        }
      }

      disconnectedCallback() {
        if (this.onVariant && window.jQuery) {
          window.jQuery(window).off('cc-variant-updated', this.onVariant);
        }
      }

      // Kiekis įrašomas į paslėptą laukelį arba, jei įjungtas, į temos kiekio laukelį
      setQuantity(qty) {
        const hidden = this.querySelector('[data-bt-qty]');
        if (hidden) {
          hidden.value = qty;
          return;
        }
        const form = document.getElementById(this.dataset.form);
        const input = form && form.querySelector('[name="quantity"]');
        if (input) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      money(cents) {
        return this.formatter.format(cents / 100);
      }

      updatePrices() {
        this.querySelectorAll('.bt-bundle__tier').forEach((tier) => {
          const qty = parseInt(tier.dataset.qty, 10);
          const pct = parseFloat(tier.dataset.pct) || 0;
          const unitAfter = Math.round((this.price * (100 - pct)) / 100);
          const unit = tier.querySelector('[data-bt-unit]');
          const regular = tier.querySelector('[data-bt-regular]');
          const saved = tier.querySelector('[data-bt-saved]');
          if (unit) unit.textContent = this.money(unitAfter);
          if (regular) regular.textContent = this.money(this.price);
          if (saved) saved.textContent = this.money((this.price - unitAfter) * qty);
        });
      }
    }
  );
}